export class BimBuildingaddress {
    public id: number;
    public description: string;
    public northof: number;
    public southof: number;
    public westof: number;
    public eastof: number;
    public exclude3D: boolean;
}
